<template>
    <table class="pageNext" >
        <!--
        rc:{{ this.recordCount }}, pageCount:{{ this.pageCount() }}, curPa:{{ this.currentPage  }}
        -->
        <tr>
            <td>
        <v-btn @click="previousPage(false)" small outlined style="_float: right" :disabled="currentPage < 2">
            &lt;&lt; </v-btn>
        </td>
        <td>
        <v-btn @click="nextPage(false)" small outlined style="float: right"
            :disabled="currentPage >= pageCount()">>> </v-btn>
        </td>
        </tr>
        <tr><td colspan="2"><span class="indicatorePagine">{{ indicatorePagina()}} </span></td></tr>
            
    </table>
    
</template>
<script>
export default {
    props:
        {
     currentPage:{type: Number,
        default:1,required:true }
        ,      
        pageSize: {type:Number,required:false, default:10},
        
        recordCount:{type:Number,required:true, default:0}
     },
    data: () => ({
        pageIndicator:''
    }),
    methods: {
        indicatorePagina(){
            if (this.recordCount==0){
                return 'Nessun dato';
            }
            return 'Pag. '+this.currentPage+' di '+this.pageCount()
        },
        pageCount(){
            return Math.ceil(this.recordCount/this.pageSize);
        },
        
        currentpageChanged(page){
          //  this.currentpage = page;
            this.pageIndicator = "pag. " + page + " di " + this.recordCount/this.pageSize;
            
        },
        notifySetCurrentPage(page) {
            // const max=this.listaRilieviAll.length;
            this.$emit("setCurrentPage",page);
            
            /*this.listaRilievi = [];
            let count = 0;
            for (
                let index = (page - 1) * this.navigator.pages.pageSize;
                index < this.listaRilieviAll.length;
                index++
            ) {
                const element = this.listaRilieviAll[index];
                this.listaRilievi.push(element);
                count++;
                if (count == this.navigator.pages.pageSize) {
                    break;
                }
            }*/
            
        },
        canChangePage() {
            return true;
        },
        previousPage(scroll) {
            if (!this.canChangePage()) {
                return;
            }
            const p = this.currentPage -1;
            //this.currentPage=p;
            if (p > 1) {
                this.notifySetCurrentPage(p );
            }
            if (scroll) {
                this.toTop();
            }
        },
        nextPage(scroll) {
            if (!this.canChangePage()) {
                return;
            }
            const p = this.currentPage+1;
            //this.currentPage=p;
            if (p < this.pageCount()) {
                this.notifySetCurrentPage(p );
            }
            if (scroll) {
                this.toTop();
            }
        },

    }
}
</script>
<style scoped>
.pageNext td{
    padding-left: 0.2rem;
    padding-right: 0.2rem;
    text-align: center;
}
.indicatorePagine{
    font-size: 0.7rem;;
}
</style>